module.exports = __webpack_public_path__ + "img/avatar7.71ad27ae.png";